// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1UxeE","headline":"_2BswZ"};